import React, { useEffect, useState } from 'react';
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import window from '../../../assets/images/window.png'
import standalonevr from '../../../assets/images/standalonevr.png'
import meta from '../../../assets/images/meta.png'
import Tooltip from '@mui/material/Tooltip';
import playstore from '../../../assets/images/playstore.png';


const DownloadLauncher = ({ availablePlatform, show, handleClose, launchHome, setLaunchHome }) => {
    const configData = useSelector((state) => state.configSlice);

    let [launcher, setLauncher] = useState("");
    let [launcherOculus, setLauncherOculus] = useState("");
    let [launcherApk, setLauncherApk] = useState("");

    const handleDownload = async () => {
        let applicationId = configData.config.applicationId;
         let channelId = configData?.config?.channel?.uuid || "";

        try {
            const {data} = await axios.get(`${configData.config.UNO_URL}/api/application/launcher/latest-version/${applicationId}?channelId=${channelId}`);
            setLauncher(data.data.windows);
            setLauncherApk(data.data.android);
            setLauncherOculus(data.data.oculus);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        handleDownload();
    }, []);

    const popUpHandleShow = (e) => {
    };

    return (
        <>
            <Modal className='platmodaltime launchplaymodal downloadlauncher' size='xl' centered show={show} onHide={handleClose}>
                <Modal.Body className='p-5'>
                    <div className='playmodalmain'>
                        <div className='playmodalright'>
                            <div className="row">
                                <div className="col-md-6">
                                    <h2>Learn <br /> Launcher</h2>
                                    <p>Download our Launcher to access the content across different platforms</p>
                                    <div className="playmodal_rightfoot">
                                        { launchHome ? 
                                        <>
                                         <div className="diff_lanchers">
                                         
                                                <Tooltip title="Download">
                                                    <a href={launcher} title="click to download" className="true" data-mui-internal-clone-element="true">
                                                        <div className="lanchbody"><img className="vricon" src={window} alt="" />Desktop</div>
                                                    </a>
                                                    </Tooltip>
                                                    <Tooltip title="Download">
                                                    <a href={launcherOculus} aria-label="Standalone VR" className="true" title="click to download" data-mui-internal-clone-element="true">
                                                        <div className="lanchbody"><img className="vricon" src={meta} alt="" />Standalone VR</div>
                                                    </a></Tooltip>
                                                    <Tooltip title="Download">
                                                    <a href={launcher}  aria-label="PC VR" className="true" title="click to download" data-mui-internal-clone-element="true">
                                                        <div className="lanchbody"><img className="vricon" src={standalonevr} alt="" />Desktop VR</div>
                                                    </a></Tooltip>
                                                    <Tooltip title="Download">
                                                    <a href={launcherApk}  aria-label="Mobile" className="true" title="click to download" data-mui-internal-clone-element="true">
                                                        <div className="lanchbody"><img className="vricon" src={playstore} alt="" />Mobile</div>
                                                    </a></Tooltip>
                                        </div>
                                                </>
    
                                        :
                                        <>
                                         <div className="diff_lanchers">
                                            {show && availablePlatform && (
                                                <>  
                                                <Tooltip title={availablePlatform.some(platform => platform.name === "Desktop") ? "Download" : "Coming Soon"}>
                                                    <a href={availablePlatform.some(platform => platform.name === "Desktop") ? launcher : undefined} aria-label="Desktop" className={availablePlatform.some(platform => platform.name === "Desktop") ? "true" : "false"} title="click to download" data-mui-internal-clone-element="true">
                                                        <div className="lanchbody"><img className="vricon" src={window} alt="" />Desktop</div>
                                                    </a>
                                                    </Tooltip>
                                                    <Tooltip title={availablePlatform.some(platform => platform.name === "Standalone VR") ? "Download" : "Coming Soon"}>
                                                    <a href={availablePlatform.some(platform => platform.name === "Standalone VR") ? launcherOculus : undefined} aria-label="Standalone VR" className={availablePlatform.some(platform => platform.name === "Standalone VR") ? "true" : "false"} title="click to download" data-mui-internal-clone-element="true">
                                                        <div className="lanchbody"><img className="vricon" src={meta} alt="" />Standalone VR</div>
                                                    </a></Tooltip>
                                                    <Tooltip title={availablePlatform.some(platform => platform.name === "Desktop VR") ? "Download" : "Coming Soon"}>
                                                    <a href={availablePlatform.some(platform => platform.name === "Desktop VR") ? launcher : undefined}  aria-label="PC VR" className={availablePlatform.some(platform => platform.name === "Desktop VR") ? "true" : "false"} title="click to download" data-mui-internal-clone-element="true">
                                                        <div className="lanchbody"><img className="vricon" src={standalonevr} alt="" />Desktop VR</div>
                                                    </a></Tooltip>
                                                    <Tooltip title={availablePlatform.some(platform => platform.name === "Mobile") ? "Download" : "Coming Soon"}>
                                                    <a href={availablePlatform.some(platform => platform.name === "Mobile") ? launcherApk : undefined}  aria-label="Mobile" className={availablePlatform.some(platform => platform.name === "Mobile") ? "true" : "false"} title="click to download" data-mui-internal-clone-element="true">
                                                        <div className="lanchbody"><img className="vricon" src={playstore} alt="" />Mobile</div>
                                                    </a></Tooltip>
                                                </>
                                            )}
                                        </div>
                                        
                                        </>
                                        
                                    }
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
}

export default DownloadLauncher;
